/**
 * Prints a message to the console only in non-production environments.
 */
const Print = (type, value) => {
	// eslint-disable-next-line no-undef
	if (process.env.NODE_ENV === "production") {
		return;
	}

	switch (type) {
		case "warn":
		case "warning":
			console.warn(value);
			break;

		case "info": {
			console.info(value);
			break;
		}

		default:
			console.log(value);
			break;
	}
};

export default Print;
